import React, { Fragment, Component } from "react";
import { withLastLocation } from "react-router-last-location";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "../../components/table";
import get from "../../helpers/lodashUtils/get";
import { getUploadTableData } from "../../actions/getOutletData";
import { AnchorText } from "./components/ProjectCard";
import dateUtils from "../../helpers/utils/dateUtils";
import { StatusTagStyle } from "../../components/StatusTagStyle";
import {
    completed,
    accepted,
    processing,
    cancelled,
    cinnabar300,
    curiousBlue300,
    white,
} from "../../theme/colors";
import CheckBox from "../../components/ui/CheckBox";
import processTable from "../../actions/processOutlet";
import processSubProjectTable from "../../actions/processOutletSubProject";
import { ConfirmationModal } from "./components/ConfirmationModal";
import triggerNotification from "../../actions/triggerNotification";
import { Button } from "../../components/Button";
import RefreshIcon from "@material-ui/icons/Refresh";
import appendToSearch from "../../helpers/utils/appendToSearch";
import styled from 'styled-components';

const Bold = styled.p`
 font-weight: bold;
`;

const getErrorMessage = (error) => {
    if (!error) return "Something went wrong. Try Again";
    if (error.detail) return error.detail;
    if (error[0]) return error[0];
    if (Array.isArray(error) && error[0]) return error[0];
    const keys = Object.keys(error);
    const nonStatusKey = keys.find(k => k !== 'status' && k !== 'url');
    if (nonStatusKey) {
        if (typeof error[nonStatusKey] === 'string') return error[nonStatusKey];
        if (Array.isArray(error[nonStatusKey]) && error[nonStatusKey][0]) return error[nonStatusKey][0];
    }
    return "Something went wrong. Try Again";
};

class BulkTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableData: [],
            open: false,
            confirmationAction: null,
            confirmationText: `Confirming will create  these ${props.keyValue} in the  ${props.keyValue} master.
      This cannot be rolled back.`,
            isLoading: false,
            tickOrCancelClicked: false,
        };
    }

    toggleSelect = (id) => {
        const { selectedRows, setSelectedRows } = this.props;
        const isEditDisabled = selectedRows.length === 0;

        const newSelected =
            selectedRows.includes(id)
                ? []
                : [id];

        setSelectedRows(newSelected);
    };




    componentDidMount = () => {
        this.setState({ isLoading: true });
        this.triggerTableData();
    };

    triggerTableData = (isManual = false) => {
        const { keyValue } = this.props;
        const { tableData } = this.state;

        if (!isManual && keyValue === "tds_tracker" && tableData && tableData.some(item => item.status === "under_activation")) {
            this.setState({ isLoading: false });
            return;
        }

        this.setState({ isLoading: true });
        const { location } = this.props;
        const qs = location.search ? location.search.replace("?", "&") : "";

        let otherParam = ""

        if (location?.state?.bulkUploadType === "workflow_payout_plotting") {
            otherParam = `&config__name=sub_project&config__value=${location?.state?.subProjectId}`
        } else if (this.props?.bulkUploadType === "survey_questions" || this.props?.bulkUploadType === "questions" || this.props?.bulkUploadType === "enrollment_questions") {
            otherParam = this.props?.downloadParam
        } else if (this.props?.bulkUploadType === "enrollment_answers") {
            const subProjId = location?.state?.subProjectId || location?.state?.subProject;
            otherParam = `&config__name=sub_project&config__value=${subProjId}`
        }

        getUploadTableData(`${this.props.keyValue}${qs}`, otherParam)
            .then((response) => {
                const results = (response && Array.isArray(response.results)) ? response.results : [];
                this.setState({
                    tableData: [...results],
                    count: response?.count || 0,
                    previous: response?.previous || null,
                    next: response?.next || null,
                    current: response?.current_page_number || 1,
                    pageSize: response?.page_size || 10,
                    isLoading: false,
                });
            })
            .catch((error) => {
                console.log("Error", error);
                this.setState({ isLoading: false, tableData: [] });
            });
    };

    triggerCompleted = (id) => {
        const { keyValue } = this.props;
        const { tableData } = this.state;

        if (keyValue === "tds_tracker" && tableData && tableData.some(item => item.status === "under_activation")) {
            this.props.notificationHandler({
                messageText: "A TDS Tracker bulk upload is already being processed or calculation is in progress. Please wait for it to complete before activating another.",
                status: "FAILED",
            });
            return;
        }

        this.setState({
            tickOrCancelClicked: true,
        });
        this.processTableAction(id, true);
    };

    triggerCancelled = (id) => {
        this.setState({
            tickOrCancelClicked: true,
        });
        this.processTableAction(id, false);
    };

    onPageChange = (pageNumber, b, c, d) => {
        const { history, location } = this.props;
        history.push({
            route: "/",
            state: { ...history.location.state },
            search: appendToSearch(location.search, {
                page: pageNumber,
            }),
        });
    };

    processTableAction = (id, isActivate) => {
        const { location } = this.props;
        let projId = get(location, "state.subProjectId");

        const subProjectId = this.props.keyValue === "bulk_kyc"
            ? location.state?.metaDetailsss?.subProjectId
            : this.props.keyValue === "bulk_sku_assign"
                ? location.state.sub_project
                : null;


        this.setState({
            open: true,
            confirmationText: isActivate
                ? (<div>{`Confirming will create  these  ${this.props.keyValue} in the project  ${this.props.keyValue} master.
      This cannot be rolled back.`} <Bold>{`Any ${this.props.keyValue} upload in this project will be cancelled`} </Bold></div>)
                : `Confirming will cancel the job. This cannot be rolled back.`,
            confirmationAction: () => {
                if (this.props.keyValue === 'bulk_kyc' || this.props.keyValue === "bulk_sku_assign") {
                    let key = this.props.keyValue
                    if (this.props.downloadParam.includes("campaign=")) {
                        key = `${key}${this.props.downloadParam}`
                    }

                    console.log(`downloadParam >> >> ${key} ${subProjectId}`);


                    processSubProjectTable(id, projId, isActivate, key, this.props.isSKU, this.props.question_group, subProjectId)
                        .then((response) => {
                            let messageText = response.detail;
                            if (response && response.status === "under_activation") {
                                messageText = "File is under activation";
                            }
                            this.props.notificationHandler({
                                messageText: messageText || "File is under activation",
                                status: "SUCCESS",
                            });
                            this.setState(
                                {
                                    open: false,
                                    confirmationAction: null,
                                    tickOrCancelClicked: false,
                                },
                                () => {
                                    this.triggerTableData();
                                }
                            );
                        })
                        .catch((error) => {
                            this.setState(
                                {
                                    open: false,
                                    confirmationAction: null,
                                    tickOrCancelClicked: false,
                                },
                                () => {
                                    this.props.notificationHandler({
                                        messageText: getErrorMessage(error),
                                        status: "FAILED",
                                    });
                                }
                            );
                        });
                } else {
                    let key = this.props.keyValue
                    if (this.props.keyValue == "survey_questions") {
                        key = `${key}${this.props.activationExtraKey}`
                    }
                    processTable(id, projId, isActivate, key, this.props.isSKU, this.props.question_group)
                        .then((response) => {
                            let messageText = response.detail;
                            if (response && response.status === "under_activation") {
                                messageText = "File is under activation";
                            }
                            this.props.notificationHandler({
                                messageText: messageText || "File is under activation",
                                status: "SUCCESS",
                            });
                            this.setState(
                                {
                                    open: false,
                                    confirmationAction: null,
                                    tickOrCancelClicked: false,
                                },
                                () => {
                                    this.triggerTableData();
                                }
                            );
                        })
                        .catch((error) => {
                            this.setState(
                                {
                                    open: false,
                                    confirmationAction: null,
                                    tickOrCancelClicked: false,
                                },
                                () => {
                                    this.props.notificationHandler({
                                        messageText: getErrorMessage(error),
                                        status: "FAILED",
                                    });
                                }
                            );
                        });
                }

            },
        });
    };

    componentDidUpdate(prevProps) {
        const { location, refreshData, uploadedId } = this.props;
        if ((prevProps.refreshData === false && refreshData) || location.search !== prevProps.location.search || prevProps.uploadedId !== uploadedId) {
            this.setState({ isLoading: true });
            this.triggerTableData();
        }
    }

    render() {
        const {
            previous,
            next,
            pageSize,
            count,
            tableData,
            isLoading,
            tickOrCancelClicked,
        } = this.state;

        return (
            <Fragment>
                <ReactTable
                    rowHeight={"auto"}
                    title="History"
                    rightHeaderElements={
                        <Button
                            size="medium"
                            bgColor={curiousBlue300}
                            color={white}
                            onClick={() => {
                                this.setState({ isLoading: true });
                                this.triggerTableData(true);
                            }}
                        >
                            <RefreshIcon /> Refresh
                        </Button>
                    }
                    loading={isLoading}
                    current={previous ? previous + 1 : 1}
                    previousPage={previous}
                    nextPage={next}
                    pageSize={pageSize}
                    showTotalRecordText={true}
                    total={count}
                    onPageChange={this.onPageChange}
                    filters={[]}
                    columns={[
                        ...(this.props.showCheckboxes ? [{
                            name: "Select",
                            key: "select",
                            sortable: false,
                            width: "45px",
                            render: (data, row) => (
                                <CheckBox
                                    checked={this.props.selectedRows.includes(row.id)}
                                    onChange={() => this.toggleSelect(row.id)}
                                />
                            ),
                        }] : []),
                        {
                            name: "Job ID",
                            key: "id",
                            sortable: false,
                            width: "70px",
                        },
                        {
                            name: "Uploaded XLS",
                            key: "file",
                            sortable: false,
                            width: "155px",
                            wordBreak: "break-all",
                            render: (data) => {
                                const splitValues = data.split("/");
                                const fileName = splitValues[splitValues.length - 1];
                                return (
                                    <AnchorText href={data} target={"_blank"} title={fileName}>
                                        {fileName}
                                    </AnchorText>
                                );
                            },
                        },
                        {
                            name: "Sub Project Id",
                            key: "config.sub_project",
                            sortable: false,
                            width: "115px",
                        },
                        {
                            name: "Updated By",
                            key: "created_by.name",
                            sortable: false,
                            width: "110px",
                        },
                        {
                            name: "Updated On",
                            key: "created",
                            sortable: false,
                            width: "145px",
                            render: (data) => {
                                const updatedDate = new Date(data);
                                return `${dateUtils().getFullDate(
                                    updatedDate
                                )} | ${dateUtils().getTimeValue(updatedDate)}`;
                            },
                        },
                        {
                            name: "Status",
                            key: "status",
                            sortable: false,
                            width: "125px",
                            render: (value) => {
                                let color;
                                switch (value) {
                                    case "completed":
                                        color = completed;
                                        break;
                                    case "processing":
                                        color = processing;
                                        break;
                                    case "active":
                                    case "accepted":
                                        color = accepted;
                                        break;
                                    case "cancelled":
                                        color = cancelled;
                                        break;
                                    case "failed":
                                        color = cancelled;
                                        break;
                                    default:
                                        color = completed;
                                        break;
                                }
                                return (
                                    <StatusTagStyle bordered borderColor={color} size="small">
                                        {value === "active" ? "accepted" : value}
                                    </StatusTagStyle>
                                );
                            },
                        },
                        {
                            name: (
                                <Fragment>
                                    Total<br />Data
                                </Fragment>
                            ),
                            key: "total_objects",
                            width: "85px",
                        },
                        {
                            name: (
                                <Fragment>
                                    Total<br />Clean
                                </Fragment>
                            ),
                            key: "total_clean_objects",
                            width: "85px",
                            render: (data, obj) => {
                                return (
                                    <AnchorText
                                        href={obj.clean_objects_media_path}
                                        target={"_blank"}
                                    >
                                        {data || "--"}
                                    </AnchorText>
                                );
                            },
                        },
                        {
                            name: (
                                <Fragment>
                                    Total<br />Unclean
                                </Fragment>
                            ),
                            key: "total_unclean_objects",
                            width: "85px",
                            render: (data, obj) => {
                                return (
                                    <AnchorText
                                        href={obj.unclean_objects_media_path}
                                        target={"_blank"}
                                    >
                                        {data || "--"}
                                    </AnchorText>
                                );
                            },
                        },
                        {
                            name: (
                                <Fragment>
                                    Processed<br />Data
                                </Fragment>
                            ),
                            key: "total_validated_objects",
                            width: "100px",
                            render: (value, data) => `${value}/${data.total_objects}`,
                        },
                        {
                            name: (
                                <Fragment>
                                    Waiting<br />Queue
                                </Fragment>
                            ),
                            key: "celery_queue_length",
                            width: "90px",
                            render: (value, data) => {
                                return (
                                    <AnchorText>
                                        {data.status === "processing"
                                            ? `${data.celery_queue_index}/${data.celery_queue_length}`
                                            : "--"}
                                    </AnchorText>
                                );
                            },
                        },
                        {
                            name: " ",
                            key: "status",
                            sortable: false,
                            width: "60px",
                            render: (data, { id, total_clean_objects }) => {
                                let tickAction = null;
                                let cancelAction = null;
                                if (data === "completed") {
                                    tickAction = total_clean_objects
                                        ? this.triggerCompleted
                                        : null;
                                    cancelAction = this.triggerCancelled;
                                } else if (
                                    data === "cancelled" ||
                                    data === "accepted" ||
                                    data === "active" ||
                                    data === "failed"
                                    //|| data === "under_activation"
                                ) {
                                    return null;
                                } else {
                                    tickAction = null;
                                    cancelAction = this.triggerCancelled;
                                }
                                return (
                                    <Fragment>
                                        <div
                                            style={{ width: 28, height: 16, }}
                                            onClick={() => {
                                                // !tickOrCancelClicked && tickAction && tickAction(id);
                                            }}
                                        >
                                            {/* <CheckBox
                                                checked={true}
                                                disabled={
                                                    tickAction ? tickOrCancelClicked || false : true
                                                }
                                            /> */}
                                        </div>

                                        <div
                                            onClick={() => {
                                                !tickOrCancelClicked && tickAction && tickAction(id);
                                            }}
                                        >
                                            <CheckBox
                                                checked={true}
                                                disabled={
                                                    tickAction ? tickOrCancelClicked || false : true
                                                }
                                            />
                                        </div>
                                        <div
                                            onClick={() => {
                                                !tickOrCancelClicked &&
                                                    cancelAction &&
                                                    cancelAction(id);
                                            }}
                                        >
                                            <CheckBox
                                                checked={true}
                                                isTick={false}
                                                background={cinnabar300}
                                                disabled={
                                                    cancelAction ? tickOrCancelClicked || false : true
                                                }
                                            />
                                        </div>
                                    </Fragment>
                                );
                            },
                        },
                    ]}
                    showPagination={true}
                    data={tableData || []}
                />
                <ConfirmationModal
                    open={this.state.open}
                    noAction={() => {
                        this.setState({
                            open: false,
                            confirmationAction: null,
                            tickOrCancelClicked: false,
                        });
                    }}
                    yesAction={this.state.confirmationAction}
                    confirmationText={this.state.confirmationText}
                    proceedText={"Do you want to proceed?"}
                    closeAction={() => {
                        this.setState({
                            open: false,
                            confirmationAction: null,
                            tickOrCancelClicked: false,
                        });
                    }}
                />
            </Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        notificationHandler: bindActionCreators(triggerNotification, dispatch),
    };
};

export default withLastLocation(connect(null, mapDispatchToProps)(BulkTable));
